import React from 'react';
import { useFeatureFlags } from '@shared/flags/FeatureFlagProvider';
import OrgReportsPage from './OrgReportsPage';
import NgrReportsPage from './NgrReportsPage';

/**
 * What `/reports` renders.
 *
 * Next Gen Reporting is not feature-complete for production, so legacy
 * reporting is the default surface (decision 2026-08-19, superseding the
 * 2026-08-14 ungated launch). An org only sees NGR once `next-gen-reporting`
 * is turned on for it in LaunchDarkly.
 *
 * The flag decides which UI mounts; it is NOT the access control. Every
 * /api/ngr route re-evaluates the same flag server-side and 404s for
 * unflagged orgs, so a stale or spoofed client value cannot reach NGR data.
 *
 * Both surfaces stay reachable by direct URL regardless of the flag —
 * /reports-legacy and /reports-next — which is what makes the flag a true
 * two-way switch during the rollout.
 */
const ReportsRouteSwitch: React.FC = () => {
  const { flags } = useFeatureFlags();
  return flags['next-gen-reporting'] ? <NgrReportsPage /> : <OrgReportsPage />;
};

export default ReportsRouteSwitch;
